import React, { useState } from 'react'
import PropTypes from 'prop-types'
import LoadingIcon from './icons/LoadingIcon'

const randomTextArray = [
  "One moment...",
  "Searching for hotels...",
  "Just a moment please...",
  "Finding hotel rooms...",
  "Hang on just a second..."
]

const Loading = ({randomText, searchReloading, loadingIconClassName="builder", className = ""}) => {
  const [ text ] = useState(
    randomTextArray[Math.floor(Math.random() * randomTextArray.length)]
  )

  const displayRandomText = () => <h2 className="random-text">{ text }</h2>

  const _renderReloadGuidance = () => searchReloading && (
    <div className="reloading">
      <p>One moment...</p>
      <h2>We&lsquo;re updating availability</h2>
    </div>
  )

  return (
    <div className={`loading overlay${className}`}>
      { randomText && !searchReloading && displayRandomText() }
      <LoadingIcon className={loadingIconClassName} />
      { _renderReloadGuidance() }
    </div>
  )
}

Loading.propTypes = {
  randomText: PropTypes.bool,
  searchReloading: PropTypes.bool,
  loadingIconClassName: PropTypes.string,
  className: PropTypes.string
}

Loading.defaultProps = {
  randomText: false
}


export default Loading
